import script from "./question-answer-ss6.vue?vue&type=script&setup=true&lang=ts"
export * from "./question-answer-ss6.vue?vue&type=script&setup=true&lang=ts"

import "./question-answer-ss6.vue?vue&type=style&index=0&id=059184f4&scoped=true&lang=scss"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-059184f4"]])

export default __exports__